// Adapted from the coolname Python project: https://github.com/alexanderlukanin13/coolname

export const animals = [
  'earthworm',
  'leech',
  'worm',
  'scorpion',
  'spider',
  'tarantula',
  'barnacle',
  'crab',
  'crayfish',
  'lobster',
  'pillbug',
  'prawn',
  'shrimp',
  'ant',
  'bee',
  'beetle',
  'bug',
  'bumblebee',
  'butterfly',
  'caterpillar',
  'cicada',
  'cricket',
  'dragonfly',
  'earwig',
  'firefly',
  'grasshopper',
  'honeybee',
  'hornet',
  'inchworm',
  'ladybug',
  'locust',
  'mantis',
  'mayfly',
  'mosquito',
  'moth',
  'sawfly',
  'silkworm',
  'termite',
  'wasp',
  'woodlouse',
  'centipede',
  'millipede',
  'pronghorn',
  'antelope',
  'bison',
  'buffalo',
  'bull',
  'chamois',
  'cow',
  'gazelle',
  'gaur',
  'goat',
  'ibex',
  'impala',
  'kudu',
  'markhor',
  'mouflon',
  'muskox',
  'nyala',
  'sheep',
  'wildebeest',
  'yak',
  'zebu',
  'alpaca',
  'camel',
  'llama',
  'vicugna',
  'caribou',
  'chital',
  'deer',
  'elk',
  'moose',
  'pudu',
  'reindeer',
  'sambar',
  'wapiti',
  'beluga',
  'dolphin',
  'narwhal',
  'orca',
  'porpoise',
  'whale',
  'donkey',
  'horse',
  'stallion',
  'zebra',
  'giraffe',
  'okapi',
  'hippo',
  'rhino',
  'boar',
  'hog',
  'pig',
  'swine',
  'warthog',
  'peccary',
  'buzzard',
  'eagle',
  'goshawk',
  'harrier',
  'hawk',
  'vulture',
  'duck',
  'goose',
  'swan',
  'teal',
  'bird',
  'hummingbird',
  'swift',
  'kiwi',
  'potoo',
  'seriema',
  'cassowary',
  'emu',
  'condor',
  'auk',
  'avocet',
  'guillemot',
  'kittiwake',
  'puffin',
  'seagull',
  'skua',
  'stork',
  'dodo',
  'dove',
  'pigeon',
  'kingfisher',
  'tody',
  'bustard',
  'coua',
  'coucal',
  'cuckoo',
  'koel',
  'malkoha',
  'roadrunner',
  'kagu',
  'caracara',
  'falcon',
  'kestrel',
  'chachalaca',
  'chicken',
  'curassow',
  'grouse',
  'guan',
  'junglefowl',
  'partridge',
  'peacock',
  'pheasant',
  'quail',
  'rooster',
  'turkey',
  'loon',
  'coot',
  'crane',
  'turaco',
  'hoatzin',
  'bullfinch',
  'crow',
  'jackdaw',
  'jaybird',
  'finch',
  'lyrebird',
  'magpie',
  'myna',
  'nightingale',
  'nuthatch',
  'oriole',
  'oxpecker',
  'raven',
  'robin',
  'rook',
  'skylark',
  'sparrow',
  'starling',
  'swallow',
  'waxbill',
  'wren',
  'heron',
  'ibis',
  'jacamar',
  'piculet',
  'toucan',
  'toucanet',
  'woodpecker',
  'flamingo',
  'grebe',
  'albatross',
  'fulmar',
  'petrel',
  'spoonbill',
  'ara',
  'cockatoo',
  'kakapo',
  'lorikeet',
  'macaw',
  'parakeet',
  'parrot',
  'penguin',
  'ostrich',
  'boobook',
  'owl',
  'cormorant',
  'frigatebird',
  'pelican',
  'quetzal',
  'trogon',
  'axolotl',
  'bullfrog',
  'frog',
  'newt',
  'salamander',
  'toad',
  'angelfish',
  'barracuda',
  'carp',
  'catfish',
  'dogfish',
  'goldfish',
  'guppy',
  'eel',
  'flounder',
  'herring',
  'lionfish',
  'mackerel',
  'oarfish',
  'perch',
  'salmon',
  'seahorse',
  'sturgeon',
  'sunfish',
  'tench',
  'trout',
  'tuna',
  'wrasse',
  'sawfish',
  'shark',
  'stingray',
  'jellyfish',
  'alligator',
  'caiman',
  'crocodile',
  'gharial',
  'starfish',
  'urchin',
  'hedgehog',
  'coyote',
  'dingo',
  'dog',
  'fennec',
  'fox',
  'hound',
  'jackal',
  'tanuki',
  'wolf',
  'bobcat',
  'caracal',
  'cat',
  'cougar',
  'jaguar',
  'jaguarundi',
  'leopard',
  'lion',
  'lynx',
  'manul',
  'ocelot',
  'panther',
  'puma',
  'serval',
  'smilodon',
  'tiger',
  'wildcat',
  'aardwolf',
  'binturong',
  'cheetah',
  'civet',
  'fossa',
  'hyena',
  'meerkat',
  'mongoose',
  'badger',
  'coati',
  'ermine',
  'ferret',
  'marten',
  'mink',
  'otter',
  'polecat',
  'skunk',
  'stoat',
  'weasel',
  'wolverine',
  'seal',
  'walrus',
  'raccoon',
  'ringtail',
  'bear',
  'panda',
  'bat',
  'armadillo',
  'elephant',
  'mammoth',
  'mastodon',
  'mole',
  'hyrax',
  'bandicoot',
  'bettong',
  'cuscus',
  'kangaroo',
  'koala',
  'numbat',
  'quokka',
  'quoll',
  'wallaby',
  'wombat',
  'echidna',
  'platypus',
  'tapir',
  'anteater',
  'sloth',
  'agouti',
  'capybara',
  'chinchilla',
  'chipmunk',
  'degu',
  'dormouse',
  'gerbil',
  'gopher',
  'groundhog',
  'jackrabbit',
  'jerboa',
  'hamster',
  'hare',
  'lemming',
  'marmot',
  'mouse',
  'muskrat',
  'porcupine',
  'rabbit',
  'rat',
  'squirrel',
  'vole',
  'ape',
  'baboon',
  'bonobo',
  'capuchin',
  'chimpanzee',
  'galago',
  'gibbon',
  'gorilla',
  'lemur',
  'lori',
  'macaque',
  'mandrill',
  'marmoset',
  'monkey',
  'orangutan',
  'tamarin',
  'tarsier',
  'uakari',
  'dugong',
  'manatee',
  'shrew',
  'aardwark',
  'clam',
  'cockle',
  'mussel',
  'oyster',
  'scallop',
  'shellfish',
  'ammonite',
  'cuttlefish',
  'nautilus',
  'octopus',
  'squid',
  'limpet',
  'slug',
  'snail',
  'sponge',
  'tuatara',
  'agama',
  'chameleon',
  'dragon',
  'gecko',
  'iguana',
  'lizard',
  'pogona',
  'skink',
  'adder',
  'anaconda',
  'asp',
  'boa',
  'cobra',
  'copperhead',
  'mamba',
  'python',
  'rattlesnake',
  'sidewinder',
  'snake',
  'taipan',
  'viper',
  'tortoise',
  'turtle',
  'dinosaur',
  'raptor',
  'mushroom'
]
